export default __webpack_public_path__ + "static/media/moot-court-new.d287356d.webp";